import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'bn-care-plan-editor-shell',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './care-plan-editor-shell.component.html',
  styleUrl: './care-plan-editor-shell.component.scss',
})
export class CarePlanEditorShellComponent {
  readonly heading = input.required<string>();
  readonly headingId = input.required<string>();
}
